export type ProductMode = "pgy" | "yxyclinic" | "scprecord" | "xhchealth";

/** 产品功能开关：业务组件只读取 manifest，禁止散点判断产品名 */
export interface ProductFeatures {
  /** 教学自学模式入口（界面裁剪，实际可用性仍须满足账号与服务端权益） */
  teach: boolean;
}

/**
 * 产品品牌壳：仅承载品牌名、默认入口与界面开关。
 * 页签可用性不再是构建期产品差异，统一由租户权益（capabilityStore）推导。
 */
export interface ProductConfig {
  mode: ProductMode;
  title: string;
  defaultTab: string;
  features: ProductFeatures;
}

/** 对话页签全集：构建期不按产品裁剪，运行时由租户已开通权益决定展示哪些 */
export const CHAT_TAB_DEFINITIONS = [
  { key: "diagnosisTreatment", label: "诊断治疗" },
  { key: "syndromeDifferentiation", label: "理法方药" },
  { key: "medicalWriting", label: "病历书写" },
  { key: "basicHealthCare", label: "病历质控" },
  { key: "tcmHealthCare", label: "健康管理" },
  { key: "publicHealthService", label: "慢病管理" },
] as const;

/** 页签全集键（顺序即未授权时的回退顺序）；可用性仍由权益门禁判定 */
export const chatTabKeys: string[] = CHAT_TAB_DEFINITIONS.map((tab) => tab.key);

const PRODUCT_CONFIGS: Record<ProductMode, ProductConfig> = {
  pgy: {
    mode: "pgy",
    title: "蒲公英医学决策支持系统",
    defaultTab: "diagnosisTreatment",
    features: { teach: true },
  },
  yxyclinic: {
    mode: "yxyclinic",
    title: "银杏叶门诊信息系统",
    defaultTab: "diagnosisTreatment",
    features: { teach: false },
  },
  scprecord: {
    mode: "scprecord",
    title: "石菖蒲医案通系统",
    defaultTab: "medicalWriting",
    features: { teach: false },
  },
  xhchealth: {
    mode: "xhchealth",
    title: "仙鹤草健康管理系统",
    defaultTab: "tcmHealthCare",
    features: { teach: false },
  },
};

function resolveProductMode(): ProductMode {
  const mode = String(import.meta.env.VITE_PRODUCT_MODE || "pgy").trim();
  return mode in PRODUCT_CONFIGS ? (mode as ProductMode) : "pgy";
}

export const productMode = resolveProductMode();
export const productConfig = PRODUCT_CONFIGS[productMode];
/** 当前产品的功能开关（教学入口等界面裁剪的唯一读取点） */
export const productFeatures: ProductFeatures = productConfig.features;
export const defaultChatTab: string = productConfig.defaultTab;
